import './products-compare.component.pug'
import './products-compare.component.scss'

import { Swiper } from 'swiper'

document
  .querySelectorAll('.products-compare__items.swiper-container')
  .forEach((swiperElement) => {
    new Swiper(swiperElement, {
      slidesPerView: 1,
      spaceBetween: 4,
      simulateTouch: false,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 8
        }
      }
    })
  })

document.querySelectorAll('.products-compare-hype').forEach((root) => {
  import(
    /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
  ).then(({ ScrollMagic, TweenLite }) => {
    const controller = new ScrollMagic.Controller()
    const scene = new ScrollMagic.Scene({
      offset: -window.innerHeight / 2,
      duration: '200%',
      triggerElement: root
    }).addTo(controller)
    const lines = root.querySelectorAll('.products-compare-hypeline')
    scene.on('progress', ({ progress }) => {
      const percents = +(10 * progress).toFixed(2)
      TweenLite.to(
        lines[0],
        {
          translateX: `${-percents}%`
        },
        0
      )
      TweenLite.to(
        lines[1],
        {
          translateX: `${percents}%`
        },
        0
      )
    })
  })
})
